












































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  IUnreadNotification,
  UnreadNoti
} from '@/models/Notification'
import UnreadNotification from '@/components/UnreadNotification.vue'
import NotificationService from '@/services/NotificationService'
import GroupService from '@/services/GroupService'
import { getUnreadCount, updateUnreadCount } from '@/helpers/GetNotificationCount'
import i18n from '@/lang'
import { unreadNotificationRef } from '@/firebase'
import {
  appendUniqueById,
  carryOverSelection
} from '@/helpers/NotificationList'

import Notification from '@/store/modules/Notification'
import store from '@/store'
import { getModule } from 'vuex-module-decorators'
//@ts-ignore
import _ from 'lodash'

const NotificationModule = getModule(Notification, store)
// 自動更新で読んだ分まで取り直すときの上限件数（API の limit に上限が無いため、こちらで抑える）
const REFRESH_LIMIT_MAX = 100

@Component({
  components: {
    UnreadNotification
  }
})
export default class UnReadList extends Vue {
  groupsUserJoin: any[] = []
  groupFilterId: any = null
  groupFilterName: string = ''
  notifications: IUnreadNotification[] = []
  private page: number = 1
  showLoadMore: boolean = false
  // 「絞り込み」ボタンで確定したグループ（null = すべてのグループ）。
  // プルダウンを選んだだけでは変わらない。続きの読み込み・自動更新はこの条件で取得する
  private appliedGroupId: number | null = null
  // 取得の通し番号。自動更新が続けて走ったとき、古い応答で一覧を上書きしないために使う
  private requestSeq: number = 0
  // いま走っている最新の取得が自動更新（取り直し）か。自動更新の応答が「もっと見る」に追い越されて捨てられたら、
  // refreshDropped を立て、最新の取得が終わったところで自動更新をもう一度だけ行う（新しい通知が次の自動更新まで出ないのを防ぐ）
  private inFlightReplace: boolean = false
  private refreshDropped: boolean = false
  isLoading: boolean = false
  isLoadingLoadMore: boolean = false
  private loadmoreAfterMarkReadNotifications: boolean = false
  unreadCount: number = this.$store.state.notification.unreadCount
  private optionSelectAllGroup: any = {
    id: null,
    name: i18n.t('notification.all_group')
  }
  private unsubscribe: any

  async created() {
    this.getAllGroupUserJoin()
    this.getNotificationUnread()
    getUnreadCount()

    // firebase get change unread notification
    this.handleRealtime()
  }

  destroyed() {
    if (this.unsubscribe) this.unsubscribe()
  }

  @Watch('$store.state.userInfo.user.info.id')
  handleRealtime() {
    let trackingRealtime = true
    const userId = this.$store.state.userInfo.user.info.id
    if (!userId) return
    if (this.unsubscribe) this.unsubscribe()
    const start = this.moment()
      .subtract(1, 'm')
      .toDate()
    this.unsubscribe = unreadNotificationRef
      .where('userIds', 'array-contains', userId)
      .where('createdAt', '>', start)
      .onSnapshot((querySnapshot: any) => {
        if (trackingRealtime) {
          trackingRealtime = false
        } else {
          // 他の端末で既読にされると件数が減り、表示中のページ番号のままでは
          // 取得位置がずれて表示済みの項目が重なる。読んだ分までを先頭から取り直して置き換える
          this.refreshNotificationUnread()
          getUnreadCount()
        }
      })
  }

  async getAllGroupUserJoin() {
    await GroupService.getAllGroupCompact().then(res => {
      if (res.status === 200) {
        this.groupsUserJoin = res.data.data
      }
    })

    this.groupsUserJoin.unshift(this.optionSelectAllGroup)
    this.groupFilterId = this.optionSelectAllGroup.id
    this.groupFilterName = this.optionSelectAllGroup.name
  }

  selectGroupFilter(index: number) {
    let selectedGroupFilter: any = this.groupsUserJoin[index]
    this.groupFilterId = selectedGroupFilter.id
    this.groupFilterName = selectedGroupFilter.name
  }

  /**
   * getNotificationUnreadCommon
   */
  async getNotificationUnreadCommon(
    group_id?: number | null,
    replace: boolean = false,
    limitOverride?: number
  ) {
    const seq = ++this.requestSeq
    if (this.inFlightReplace && !replace) this.refreshDropped = true
    this.inFlightReplace = replace
    // limitOverride があるときは、先頭から limitOverride 件を 1 回で取る（読んだ分までの取り直し）
    const requestPage = limitOverride ? 1 : this.page
    this.isLoading = requestPage <= 1
    this.isLoadingLoadMore = requestPage > 1
    let limit = this.$store.state.setting.setting.setting_display
      .number_item_lists

    await NotificationService.getNotificationUnread(
      limitOverride || limit,
      requestPage,
      group_id || undefined
    )
      .then(async res => {
        // あとから出した取得がある場合、この応答は古いので使わない
        if (seq !== this.requestSeq) return
        if (res.status === 200) {
          // total_pages は取得した limit で変わるため、読んだ件数（page × 通常の件数）と total で判定する
          this.showLoadMore =
            this.page * limit < res.data.meta.pagination.total

          if (requestPage === 1) {
            const total = res.data.meta.pagination.total
            if (group_id) {
              this.unreadCount = total
            } else {
              this.unreadCount = total
              updateUnreadCount(total)
            }
          }

          const data = res.data.data.map(
            (item: any) => new UnreadNoti(item, 'text-line-clamp-2')
          )

          if (replace || this.loadmoreAfterMarkReadNotifications === true) {
            this.notifications = carryOverSelection(this.notifications, data)
          } else {
            // 取得の間に件数が減ると、次のページに表示済みの項目が含まれるため id で重複を除く
            this.notifications = appendUniqueById(this.notifications, data)
          }
        }
      })
      .catch(err => {
        console.log(err)
      })

    if (seq !== this.requestSeq) return
    this.inFlightReplace = false
    this.isLoading = false
    this.isLoadingLoadMore = false
    this.loadmoreAfterMarkReadNotifications = false
    if (replace) {
      this.refreshDropped = false
    } else if (this.refreshDropped) {
      this.refreshDropped = false
      await this.refreshNotificationUnread()
    }
  }

  /**
   * getNotificationUnread
   */
  getNotificationUnread() {
    return this.refreshNotificationUnread()
  }

  /**
   * refreshNotificationUnread
   * 確定済みの絞り込み条件で、読み終えたページまで（上限 REFRESH_LIMIT_MAX 件）を先頭から 1 回で取り直して一覧を置き換える。
   * 1 ページ目だけに戻すと「もっと見る」で読んだ分とそのチェックが自動更新のたびに消えるため。
   * page は読んだページのまま残すので、次の「もっと見る」は続きから取れる
   */
  refreshNotificationUnread() {
    const perPage = this.$store.state.setting.setting.setting_display
      .number_item_lists
    const pages = Math.max(
      1,
      Math.min(this.page, Math.floor(REFRESH_LIMIT_MAX / perPage))
    )
    this.page = pages
    return this.getNotificationUnreadCommon(
      this.appliedGroupId,
      true,
      perPage * pages
    )
  }

  /**
   * getNotificationUnreadByGroup
   */
  async getNotificationUnreadByGroup() {
    this.page = 1
    this.notifications = []
    this.loadmoreAfterMarkReadNotifications = false
    this.appliedGroupId = this.groupFilterId || null
    if (this.groupFilterId) {
      await this.getNotificationUnreadCommon(this.groupFilterId)
    } else {
      await this.getNotificationUnreadCommon()
      this.unreadCount = this.$store.state.notification.unreadCount
    }

    ;(this.$refs.unreadNotification as any).isCheckAll = false
  }

  /**
   * loadMoreNotification
   */
  async loadMoreNotification() {
    this.page++
    if (this.loadmoreAfterMarkReadNotifications === true) {
      this.page = 1
    }
    await this.getNotificationUnreadCommon(this.appliedGroupId)
    this.loadmoreAfterMarkReadNotifications = false
    ;(this.$refs.unreadNotification as any).isCheckAll = false
  }

  /**
   * markUnreadNotificationIds
   */
  async markUnreadNotificationIds(notificationIds: any) {
    this.$blockui.show()
    await NotificationService.markReadedNotification(notificationIds)
      .then(async res => {
        if (res.status === 200) {
          const readIds = notificationIds.notifications
          this.notifications = this.notifications.filter(
            ({ id }) => !readIds.includes(id)
          )

          await getUnreadCount()
          NotificationModule.CHANGE_NOTIFICATION_UNREAD()

          if (this.appliedGroupId == null) {
            this.unreadCount = this.$store.state.notification.unreadCount
          } else {
            this.unreadCount = Math.max(0, this.unreadCount - readIds.length)
          }
          this.loadmoreAfterMarkReadNotifications = true

          // fetch new data if all current notifications are mark read and still have data to fetch
          if (!this.notifications.length && this.showLoadMore) {
            await this.refreshNotificationUnread()
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => this.$blockui.hide())

    this.loadmoreAfterMarkReadNotifications = true
  }

  handleLongText(text: string) {
    return _.truncate(text, {
      length: 50,
      separator: ' '
    })
  }
}
